import React from "react";
import { DynamicFormFieldProps } from "../DynamicForm";
import { FormLabel } from ".";
import { DynamicFormField } from "../../laco-common/base/form-validation/dynamic";
import CSSEditor from "../../admin/components/editors/CSSEditor";

export const CSSEditorInput: React.FC<DynamicFormFieldProps> = (props: DynamicFormFieldProps) => {
	const field: DynamicFormField = props.field;
	const { onChange, omitLabel, autoFocusFieldKey: focusFieldKey } = props; // variant
	return (
		<>
			<div className="w-100 position-relative" id="css-editor-input">
				{!omitLabel && <FormLabel field={field} />}
				<CSSEditor
					defaultValue={field.value || {}}
					onChange={(css: string) => {
						// validate CSS
						console.log("CSS editor content changed");
						onChange(css);
					}}
				/>
			</div>
		</>
	);
};

export default CSSEditorInput;
